import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
export const legacyEmailContract = c.router({
  legacyEmailRedirect: {
    method: 'GET',
    path: '/open-link',
    query: z.object({
      link: z.string().optional(),
    }),
    responses: {
      301: z.undefined(),
    },
  },
});
